import {Component} from '@angular/core';
import {GlobalService} from "./services/global.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent{

  constructor(public globalService: GlobalService) {
    this.globalService.checkLoginState();
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/app.component.ts